import { postInfo, postRequestApiBlob } from './api';

export default {
  /*
    修改密码
  */
  hrStaffanalyzeAnalyze(data, url) {
    const nurl = url || '';
    return postInfo(`hr/staffanalyze/analyze${nurl}`, data);
  },
  hrStaffanalyzePiechart(data, url) {
    const nurl = url || '';
    return postInfo(`hr/staffanalyze/piechart${nurl}`, data);
  },
  hrStaffanalyzeLinechart(data, url) {
    const nurl = url || '';
    return postInfo(`hr/staffanalyze/linechart${nurl}`, data);
  },

  hrStaffanalyzeExport(data, url) { // 导出
    const nurl = url || '';
    return postRequestApiBlob(`hr/staffanalyze/export${nurl}`, data);
  },

};
